<div class="widget-settings d-sm-flex flex-column" [formGroup]="notificationForm">
    <h3>Notification Settings</h3>
    <div class="d-sm-flex flex-column">
        <mat-slide-toggle formControlName="emailNotificationsEnabled">
            Email Notifications Enabled
        </mat-slide-toggle>

        @if (notificationForm.get('emailNotificationsEnabled')?.value) {
            <div class="d-flex flex-column">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Email Notification Subject</mat-label>
                    <input formControlName="emailNotificationSubject" matInput placeholder="Enter email subject">
                </mat-form-field>
                <mat-form-field class="example-form-field">
                    <mat-label>Recipients</mat-label>
                    <mat-chip-grid #reactiveChipGrid aria-label="Enter reactive form keywords"
                                   formControlName="emailNotificationRecipients">
                        @for (keyword of notificationForm.get('emailNotificationRecipients')?.value; track keyword) {
                            <mat-chip-row (removed)="removeRecipient(keyword)">
                                {{ keyword }}
                                <button aria-label="'remove reactive form' + keyword" matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                        }
                    </mat-chip-grid>
                    <input (matChipInputTokenEnd)="addRecipient($event)"
                           [matChipInputAddOnBlur]="true"
                           [matChipInputFor]="reactiveChipGrid"
                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                           placeholder="Enter email recipients">
                </mat-form-field>
            </div>
        }

        <mat-slide-toggle formControlName="webhookNotificationsEnabled">
            Webhook Notifications Enabled
        </mat-slide-toggle>

        @if (notificationForm.get('webhookNotificationsEnabled')?.value) {
            <div class="d-flex flex-column">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Webhook Notification URL</mat-label>
                    <input formControlName="webhookNotificationUrl" matInput placeholder="Enter webhook URL">
                    @if (notificationForm.get('webhookNotificationUrl')?.hasError('webhookUrl') && notificationForm.get('webhookNotificationUrl')?.touched) {
                        <mat-error>
                            Enter a valid public HTTPS hostname without credentials or fragments
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
    </div>
</div>
